import { useState } from 'react';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import EcomEngineAPI from 'api/ecom_engine_api';
import { getSeaLinkBasename } from 'utils/helpers';
import ProgressButton from 'components/progress_button/progress_button';
import { useDocumentTitle } from 'tenants/sealink/utils/use_document_title';
import ResetPasswordEmailSent from './reset_password_email_sent';

const ResetPassword = () => {
  useDocumentTitle('Reset password');
  const [submissionMessage, setSubmissionMessage] = useState('');
  const [isSubmissionSucceed, setIsSubmissionSucceed] = useState();
  const [submissionClass, setSubmissionClass] = useState('alert-info');
  const [username, setUsername] = useState('');

  const basename = getSeaLinkBasename();
  const resetPasswordLinkBaseUrl = `${window.location.origin}/${basename}/account/reset-password/confirm/`;

  const onSubmit = (params, { setSubmitting, isSubmitting }) => {
    if (isSubmitting) {
      return;
    }
    setIsSubmissionSucceed();
    setSubmitting(true);
    setSubmissionMessage(null);
    setSubmissionClass('alert-info');
    setUsername(params.username);

    EcomEngineAPI.account.resetPassword(params).then((result) => {
      setSubmitting(false);

      if (result.status === 422) {
        setSubmissionClass('alert-danger');
        return setSubmissionMessage('User not found');
      }

      if (result.message) {
        setSubmissionClass('alert-danger');
        return setSubmissionMessage(result.message);
      }

      if (result.success) {
        setIsSubmissionSucceed(true);
      }
    });
  };

  const formSchema = Yup.object().shape({
    username: Yup.string().required('Username or Email is required'),
  });

  if (isSubmissionSucceed) {
    return <ResetPasswordEmailSent username={username} />;
  }

  return (
    <div className="d-grid gap-3">
      <h3>Reset Password</h3>
      <div className="content text-small">
        <p>If you are already registered but have forgotten your password:</p>
        <ol>
          <li>Enter your registered username or email.</li>
          <li>
            An email will be sent to your email address which contains
            information about password recovery.
          </li>
          <li>Please click the link in the email to reset your password.</li>
        </ol>
      </div>

      <Formik
        initialValues={{
          username: '',
          return_url: resetPasswordLinkBaseUrl,
        }}
        validationSchema={formSchema}
        onSubmit={onSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            {submissionMessage && (
              <div
                className={`alert ${submissionClass} alert-dismissible fade show`}
              >
                {submissionMessage}
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setSubmissionMessage(null)}
                />
              </div>
            )}
            <div className="form-group">
              <label htmlFor="username">Username or Email</label>
              <div>
                <Field
                  name="username"
                  className="form-control"
                  id="username"
                  placeholder="Username or Email"
                />
              </div>
              <ErrorMessage
                className="text-danger text-small mt-1"
                name="username"
                component="div"
                id="username_error"
              />
            </div>
            <ProgressButton
              type="submit"
              defaultText="Reset password"
              loading={isSubmitting}
              loadingText="Sending request..."
              succeeded={isSubmissionSucceed}
              succeededText="Email sent"
            />
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default ResetPassword;
